import React, { useEffect, useState } from 'react'
import { WhatsappButtonScreen } from '../whatsappButton/WhatsappButtonScreen'
import { FooterScreen } from '../../footer/FooterScreen'
import { Link, useParams } from 'react-router-dom'
import { NavBarScreen } from '../../navBar/NavBarScreen'
import axios from 'axios'
import { ApiStorage, ApiUrl } from '../../../services/ApiRest'

export const SingleAliance = () => {

    const { partnerId } = useParams();
    const [aliado, setaliado] = useState([])

    const getData = async () => {
        await axios.get(ApiUrl + "partner-show/" + partnerId)
            .then(response => {
                const data = response.data;
                setaliado(data);
                console.log(data);
                //cargamos los datos nuevos
                const script = document.createElement("script");
                script.src = `/assets/dataTable/dataTable.js`;
                script.async = true;
                document.body.appendChild(script);
            })
            .catch(e => {
                console.log(e)
            })
    }

    useEffect(() => {
        getData();
    }, [])



    console.log(partnerId + "************")

    return (
        <>
            <NavBarScreen var='.' />
            <br></br>
            <br></br>
            <br></br>
            <br></br>

            <div className='container pantalla-grande'>
                <br></br>
                {aliado.map((partner, index) => (
                    <div className='row' key={index}>
                        <div className='col-12 col-sm-12 col-md-6'>
                            <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item carousel-item2 active">
                                        {/* <img src={`${partner.img_1}`} style={{ width: '100%' }} className="card-img-top" alt="..."></img> */}
                                        <img src={`${ApiStorage + partner.img_logo}`} style={{ width: '100%' }} className="card-img-top" alt="..."></img>
                                    </div>
                                    <div className="carousel-item carousel-item2 ">
                                        <img src={`${ApiStorage + partner.img_1}`} style={{ width: '100%' }} className="card-img-top" alt="..."></img>
                                    </div>

                                    <div className="carousel-item carousel-item2 ">
                                        <img src={`${ApiStorage + partner.img_2}`} style={{ width: '100%' }} className="card-img-top" alt="..."></img>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" benefit="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" benefit="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>


                        </div>
                        <div className='col-12 col-sm-12 col-md-6'>


                            <h5 className='camping-letters'> {partner.province} - {partner.city}</h5>
                            <h1 className='camping-letters' style={{ textTransform: 'uppercase' }}> {partner.partner_name}</h1>
                            {/* <p className='text-justify'>{partner.description}</p> */}

                            <h6 className='camping-letters' style={{ textAlign: "center", color: "green", textTransform: 'uppercase' }}> Beneficio para clientes de Camping Chimborazo</h6>
                            <div className='text-justify preserve-whitespace' dangerouslySetInnerHTML={{ __html: partner.benefit }}></div>
                            <h6 className='camping-letters' style={{ textAlign: "center", color: "green", textTransform: 'uppercase' }}>Horario de atención:</h6>
                            <div className='text-justify preserve-whitespace' dangerouslySetInnerHTML={{ __html: partner.business_hours }}></div>

                            <p className='text-justify'><b>Dirección:</b> {partner.address}</p>
                            <div style={{ paddingTop: "1vh" }}>
                                <div className='row text-center '>
                                    <div className='  '>
                                        {
                                            ((partner.facebook !== null) || (partner.facebook !== "null")) &&
                                            <a className='btn-rs ' href={partner.facebook} target="_blank" style={{ textDecoration: 'none', padding: '6px', color: 'black' }}>
                                                <i className="fab fa-facebook    "  ></i>
                                            </a>
                                        }
                                        {
                                            ((partner.instagram !== null) || (partner.instagram !== "null"))  &&
                                            <a className='btn-rs' href={partner.instagram} target="_blank" style={{ textDecoration: 'none', padding: '6px', color: 'black' }}>
                                                <i className="fab fa-instagram  "  ></i>
                                            </a>

                                        }

                                        {
                                            ((partner.tiktok !== null) || (partner.tiktok !== "null"))  &&
                                            <a className='btn-rs' href={partner.tiktok} target="_blank" style={{ textDecoration: 'none', padding: '6px', color: 'black' }}>
                                                <i className="fab fa-tiktok   "></i>
                                            </a>
                                        }


                                    </div>

                                </div>

                            </div>



                            <br></br>
                            <div className='container text-center'>
                                <a href={`https://api.whatsapp.com/send?phone=+593${partner.phone}&text=${partner.message_for_whatsapp}`} target="_blank" style={{ padding: '5px' }}>
                                    <button benefit="button" className="btn btn-success" style={{ margin: '2vh' }}> CONTACTAR <i className="fab fa-whatsapp"></i> </button >
                                </a>
                                <a href={partner.google_maps} target="_blank" style={{ padding: '5px' }}>
                                    <button benefit="button" className="btn btn-warning" style={{ margin: '2vh' }}> UBICACIÓN EN MAPA</button >
                                </a>
                            </div>


                        </div>
                        <br></br>
                        <br></br>
                        <div className='container' style={{paddingTop:'5vh'}}>
                            <div className='text-justify preserve-whitespace camping-letters' dangerouslySetInnerHTML={{ __html: partner.about_of_business }}></div>
                        </div>
                    </div>


                ))}

            </div>

            {/* *********PANTALLA PEQUE************* */}

            <div className='container pantalla-peque'>
                <br></br>
                {aliado.map((partner, index) => (
                    <div className=' row' key={index} >
                        <h1 className='camping-letters text-center' style={{ textTransform: 'uppercase' }}> {partner.partner_name}</h1>
                        <h5 className='camping-letters text-center'>{partner.province} - {partner.city}</h5>

                        <div className='col-12 col-sm-12 col-md-6'>
                            <div id="carouselExampleControls2" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item carousel-item2 active">
                                        <img src={`${ApiStorage + partner.img_logo}`} style={{ width: '100%' }} className="card-img-top" alt="..."></img>
                                    </div>
                                    <div className="carousel-item carousel-item2 ">
                                        <img src={`${ApiStorage + partner.img_1}`} style={{ width: '100%' }} className="card-img-top" alt="..."></img>
                                    </div>
                                    <div className="carousel-item carousel-item2 ">
                                        <img src={`${ApiStorage + partner.img_2}`} style={{ width: '100%' }} className="card-img-top" alt="..."></img>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" benefit="button" data-bs-target="#carouselExampleControls2" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" benefit="button" data-bs-target="#carouselExampleControls2" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>


                        </div>
                        <div className='col-12 col-sm-12 col-md-6'>
                            <br></br>

                            <h6 className='camping-letters' style={{ textAlign: "center", color: "green", textTransform: 'uppercase' }}> Beneficio para clientes de Camping Chimborazo</h6>
                            <div className='text-justify preserve-whitespace' dangerouslySetInnerHTML={{ __html: partner.benefit }}></div>
                            <h6 className='camping-letters' style={{ textAlign: "center", color: "green", textTransform: 'uppercase' }}>Horario de atención:</h6>
                            <div className='text-justify preserve-whitespace' dangerouslySetInnerHTML={{ __html: partner.business_hours }}></div>

                            <p className='text-justify'><b>Dirección:</b> {partner.address}</p>



                            <div style={{ paddingTop: "1vh" }}>
                                <div className='row text-center '>
                                    <div className='  '>
                                    {
                                            ((partner.facebook !== null) || (partner.facebook !== "null")) &&
                                            <a className='btn-rs ' href={partner.facebook} target="_blank" style={{ textDecoration: 'none', padding: '6px', color: 'black' }}>
                                                <i className="fab fa-facebook    "  ></i>
                                            </a>
                                        }
                                        {
                                            ((partner.instagram !== null) || (partner.instagram !== "null"))  &&
                                            <a className='btn-rs' href={partner.instagram} target="_blank" style={{ textDecoration: 'none', padding: '6px', color: 'black' }}>
                                                <i className="fab fa-instagram  "  ></i>
                                            </a>

                                        }

                                        {
                                            ((partner.tiktok !== null) || (partner.tiktok !== "null"))  &&
                                            <a className='btn-rs' href={partner.tiktok} target="_blank" style={{ textDecoration: 'none', padding: '6px', color: 'black' }}>
                                                <i className="fab fa-tiktok   "></i>
                                            </a>
                                        }


                                    </div>

                                </div>

                            </div>

                            <br></br>
                            <div className='container text-center'>
                                <a href={`https://api.whatsapp.com/send?phone=+593${partner.phone}&text=${partner.message_for_whatsapp}`} target="_blank" style={{ padding: '5px' }}>
                                    <button benefit="button" className="btn btn-success" style={{ margin: '2vh' }}> CONTACTAR <i className="fab fa-whatsapp"></i> </button >
                                </a>


                                <a href={partner.google_maps} target="_blank" style={{ padding: '5px' }}>
                                    <button benefit="button" className="btn btn-warning" style={{ margin: '2vh' }}> UBICACIÓN EN MAPA</button >
                                </a>


                            </div>


                        </div>
                        <br></br>
                        <br></br>
                        <div className='container' style={{paddingTop:'5vh'}}>


                            <div className='text-justify preserve-whitespace camping-letters' dangerouslySetInnerHTML={{ __html: partner.about_of_business }}></div>


                        </div>
                    </div>
                ))}
            </div>


            <br></br>
            <br></br>
            <br></br>
            <WhatsappButtonScreen />
            <FooterScreen />

        </>
    )
}
